import * as types from './mutation-types'
import Vue from 'vue'
import contractApi from '../api/contractApi'

// 获取合同信息详情数据
export const findContract = ({ commit }, { id, data }) => {
  return new Promise((resolve, reject) => {
    contractApi.getContract(id, data, contract => {
      contractApi.getAttachments(id, attachList => {
        contract['attachList'] = attachList
        commit(types.SET_CONTRACT_DETAIL, contract)
        resolve(contract)
      }, errMsg => {
        reject(errMsg)
      })
    }, errMsg => {
      reject(errMsg)
    })
  })
}
export const findSealOut = ({ commit }, { id, data }) => {
  return new Promise((resolve, reject) => {
    contractApi.getSealOut(id, data, sealOut => {
      commit(types.SET_SEALOUT_DETAIL, sealOut)
      resolve(sealOut)
    }, errMsg => {
      reject(errMsg)
    })
  })
}
export const resetContractDetail = ({ commit }) => {
  commit(types.RESET_CONTRACT_DETAIL)
}
export const resetSealOutDetail = ({ commit }) => {
  commit(types.RESET_SEALOUT_DETAIL)
}
export const getDataList = ({ commit, state }, page) => {
  return new Promise((resolve, reject) => {
    Vue.http.post('rest/api/dataInfo', {viewtype: page.viewtype, page: page.pageNumber, rows: page.pageSize, totalPage: page.totalPage}).then(function (response) {
      if (response.data.ok && response.data.data) { //  && response.data.data.list.length > 0
        let current = response.data.data.list
        let dataList = []
        for (let i = 0; i < current.length; i++) {
          dataList.push(current[i])
        }
        let pager = {}
        let viewtype = page.viewtype
        pager.pageNumber = response.data.data.pageNumber
        pager.totalPage = response.data.data.totalPage
        pager.totalRow = response.data.data.totalRow
        pager.firstPage = response.data.data.firstPage
        pager.lastPage = response.data.data.lastPage
        pager.pageSize = 5
        pager.list = dataList
        let saveCurrent
        let refresh = page.refresh
        switch (viewtype) {
          case 'audit':
            saveCurrent = state.auditList.page.list
            if (saveCurrent.length > 0 && !refresh) {
              pager.list = state.auditList.page.list.concat(pager.list)
            }
            commit(types.LIST_INFO_AUDIT, pager)
            break
          case 'cc':
            saveCurrent = state.ccList.page.list
            if (saveCurrent.length > 0 && !refresh) {
              pager.list = state.ccList.page.list.concat(pager.list)
            }
            commit(types.LIST_INFO_CC, pager)
            break
          case 'history':
            saveCurrent = state.historyList.page.list
            if (saveCurrent.length > 0 && !refresh) {
              pager.list = state.historyList.page.list.concat(pager.list)
            }
            commit(types.LIST_INFO_HISTORY, pager)
            break
          case 'seal':
            saveCurrent = state.sealList.page.list
            if (saveCurrent.length > 0 && !refresh) {
              pager.list = state.sealList.page.list.concat(pager.list)
            }
            commit(types.LIST_INFO_SEAL, pager)
            break
          case 'file':
            saveCurrent = state.fileList.page.list
            if (saveCurrent.length > 0 && !refresh) {
              pager.list = state.fileList.page.list.concat(pager.list)
            }
            commit(types.LIST_INFO_FILE, pager)
            break
          default:
        }
        resolve()
      } else {
        reject()
      }
    }, function (response) {
      reject()
    })
  })
}
export const getSealOutDataList = ({ commit, state }, page) => {
  return new Promise((resolve, reject) => {
    Vue.http.post('rest/api/sealOutDataInfo', {viewtype: page.viewtype, page: page.pageNumber, rows: page.pageSize, totalPage: page.totalPage}).then(function (response) {
      if (response.data.ok && response.data.data) { //  && response.data.data.list.length > 0
        let current = response.data.data.list
        let dataList = []
        for (let i = 0; i < current.length; i++) {
          dataList.push(current[i])
        }
        let pager = {}
        let viewtype = page.viewtype
        pager.pageNumber = response.data.data.pageNumber
        pager.totalPage = response.data.data.totalPage
        pager.totalRow = response.data.data.totalRow
        pager.firstPage = response.data.data.firstPage
        pager.lastPage = response.data.data.lastPage
        pager.pageSize = 5
        pager.list = dataList
        let saveCurrent
        let refresh = page.refresh
        switch (viewtype) {
          case 'audit':
            saveCurrent = state.auditList.page.list
            if (saveCurrent.length > 0 && !refresh) {
              pager.list = state.auditList.page.list.concat(pager.list)
            }
            commit(types.LIST_INFO_AUDIT, pager)
            break
          case 'history':
            saveCurrent = state.historyList.page.list
            if (saveCurrent.length > 0 && !refresh) {
              pager.list = state.historyList.page.list.concat(pager.list)
            }
            commit(types.LIST_INFO_HISTORY, pager)
            break
          default:
        }
        resolve()
      } else {
        reject()
      }
    }, function (response) {
      reject()
    })
  })
}
export const clearpage = ({ commit, state }, page) => {
  commit(types.LIST_INFO_AUDIT, page)
  commit(types.LIST_INFO_CC, page)
  commit(types.LIST_INFO_HISTORY, page)
  commit(types.LIST_INFO_SEAL, page)
  commit(types.LIST_INFO_FILE, page)
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js